import User from '@dehaat/kisan-app-bl/models/User'

export type AnalyticsUserDetails = Record<string, unknown>

let superPropertiesStore: AnalyticsUserDetails = {}

export function buildUserDetails(
  user: User,
  clientCode?: string | null,
  agcFarmerId?: string | null,
): AnalyticsUserDetails {
  return {
    UserMobile: user.phone_number,
    UserName: user.full_name,
    UserLocation: user.location?.location?.coordinates,
    UserProfileSource: user.profile?.source,
    UserProfieSourceId: user.profile?.id,
    UserExternalPartnerID: user?.external_partner_id,
    UserExternalPartnerType: user?.external_partner_type,
    UserState: user.location?.state.name,
    UserDistrict: user.location?.district.name,
    UserBlock: user.location?.block.name,
    UserEmail: user.email,
    client_src: clientCode,
    AGCFarmerID: agcFarmerId,
  }
}

function sanitizeSuperProperties(
  props: AnalyticsUserDetails,
): AnalyticsUserDetails {
  const result: AnalyticsUserDetails = {}
  for (const [key, value] of Object.entries(props)) {
    if (value === undefined || value === null) continue
    result[key] = value
  }
  return result
}

export function setSuperPropertiesStore(props: AnalyticsUserDetails) {
  superPropertiesStore = sanitizeSuperProperties(props)
}

export function getSuperProperties(): AnalyticsUserDetails {
  return { ...superPropertiesStore }
}

export function clearSuperPropertiesStore() {
  superPropertiesStore = {}
}

/** Event params win on key conflict (preserves explicit per-event overrides). */
export function mergeSuperProperties<T extends Record<string, unknown>>(
  eventParams: T,
): T & AnalyticsUserDetails {
  return { ...getSuperProperties(), ...eventParams }
}

/** @internal Resets module store — for unit tests only. */
export const resetSuperPropertiesStoreForTests = () => {
  superPropertiesStore = {}
}
